<template>
  <div :class="addClass">
    <b-form-select
      v-model="lang"
      :options="options"
    />
  </div>
</template>

<script>
export default {
  props: {
    addClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    options () {
      return [
        { value: 'en', text: 'EN' },
        { value: 'pl', text: 'PL' }
      ]
    },
    lang: {
      get: function () {
        return this.$store.state.lang
      },
      set: function (lang) {
        this.$store.commit('setLang', lang)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .non-auth {
    position: absolute;
    top: 0;
    right: 0;
    margin: 1rem;
    z-index: 1;
  }
  #app .custom-select {
    border: none;
    &:focus {
        box-shadow: none;
    }
  }
</style>
